module.exports = __webpack_public_path__ + "static/media/Race Car Guy.ee840046.jpg";